import extractGoogleMapAddressComponent from './extract-google-map-address-component'

export default function(obj, place, { keepExistingFieldValues = false, excludeVenue = false}) {
  const assignValue = (locationProperty, value, override) => {
    if (!keepExistingFieldValues || override) {
      obj[locationProperty] = value
    }
  }

  assignValue('query', place.formatted_address, true)
  assignValue('street_number', extractGoogleMapAddressComponent(place.address_components, 'street_number', true))
  assignValue('street', extractGoogleMapAddressComponent(place.address_components, 'route', true))
  assignValue('postal_code', extractGoogleMapAddressComponent(place.address_components, 'postal_code', true))
  assignValue('country', extractGoogleMapAddressComponent(place.address_components, 'country', false), !obj['country'])
  assignValue('locality', extractGoogleMapAddressComponent(place.address_components, ['locality', 'postal_town'], true))
  assignValue('region', extractGoogleMapAddressComponent(place.address_components, ['administrative_area_level_1', 'administrative_area_level_2'], false))

  assignValue('latitude', place.coordinates.latitude, true)
  assignValue('longitude', place.coordinates.longitude, true)

  if (!excludeVenue) {
    assignValue('venue', place.name)
  }

  return obj
}
